"use client";

import { useQueryClient } from "@tanstack/react-query";

import { useOpenApiMutation } from "../../../../request/hooks/openApi/useOpenApiMutation";
import { keyCommunityEvent } from "./keyCommunityEvent";

export const useRequestMutationsCommunitiesAdminEvents = () => {
  const queryClient = useQueryClient();

  return {
    mutationCreateDraft: useOpenApiMutation({
      urlBackendPath: "/communities/{community_id}/admin/events/drafts",
      method: "POST",
    }),
    mutationPublishDraft: useOpenApiMutation({
      urlBackendPath:
        "/communities/{community_id}/admin/events/drafts/{encoded_segment_id}/publish",
      method: "PATCH",
      onSuccess: (data, variables) => {
        const communityId = variables.params?.path?.community_id;
        queryClient.invalidateQueries({
          queryKey: [
            "community-draft-event",
            communityId,
            variables.params?.path?.encoded_segment_id,
          ],
        });
        if (communityId !== undefined) {
          queryClient.invalidateQueries({
            queryKey: keyCommunityEvent({
              communityId,
              eventId: data.event_id,
            }),
          });
        }
      },
    }),
    mutationUpdate: useOpenApiMutation({
      urlBackendPath:
        "/communities/{community_id}/admin/events/{encoded_event_occurrence_id}",
      method: "PATCH",
      onSuccess: (data, variables) => {
        const communityId = variables.params?.path?.community_id;
        if (communityId === undefined) return;
        queryClient.invalidateQueries({
          queryKey: keyCommunityEvent({
            communityId,
            eventId: data.event_id,
          }),
        });
      },
    }),
    mutationDelete: useOpenApiMutation({
      urlBackendPath:
        "/communities/{community_id}/admin/events/{encoded_event_occurrence_id}",
      method: "DELETE",
      onSuccess: (_, variables) => {
        const communityId = variables.params?.path?.community_id;
        if (communityId === undefined) return;
        queryClient.invalidateQueries({
          queryKey: keyCommunityEvent({
            communityId,
            eventId: variables.params?.path?.encoded_event_occurrence_id ?? "",
          }),
        });
      },
    }),
    mutationCancel: useOpenApiMutation({
      urlBackendPath:
        "/communities/{community_id}/admin/events/{encoded_event_occurrence_id}/cancel",
      method: "PATCH",
      onSuccess: (_, variables) => {
        const communityId = variables.params?.path?.community_id;
        if (communityId === undefined) return;
        queryClient.invalidateQueries({
          queryKey: keyCommunityEvent({
            communityId,
            eventId: variables.params?.path?.encoded_event_occurrence_id ?? "",
          }),
        });
      },
    }),
    mutationSendNotifications: useOpenApiMutation({
      urlBackendPath:
        "/communities/{community_id}/admin/events/{encoded_event_occurrence_id}/send-notifications",
      method: "POST",
    }),
  };
};
